<mat-card appearance="outlined" *ngIf="fetchingError">
  <mat-card-content class="row">
    <mat-icon class="no-flex">error</mat-icon>
    <span>Error when fetching sessions. Try again later.</span>
  </mat-card-content>
</mat-card>

<div class="sessions-history">
  <div class="content">
    <div *ngIf="(shownSessions$ | async) as sessions" class="history">
      <ng-container *ngFor="let session of sessions">
        <div
          class="session gap"
          *ngIf="session.isGap"
          [style.width]="session.historyWidthPercentageString">
        </div>
        <div
          class="session"
          *ngIf="!session.isGap"
          [class.current]="session.status === 'current'"
          [class.critical]="session.status === 'critical'"
          [class.warning]="session.status === 'warning'"
          [class.ok]="session.status === 'ok'"
          [class.unknown]="session.status === 'unknown'"
          [style.width]="session.historyWidthPercentageString"
          [matTooltip]="!session.isGap ? 'Start: ' + session.creationTime.toLocaleString() + '\nEnd: ' + (session.closeTime ? session.closeTime.toLocaleString() + (session.unknownCloseTime ? ' (unknown)' : '') : 'Ongoing') : ''"
          matTooltipPosition="above"
          (click)="copySessionIdToClipboard(session.sessionId)">
        </div>
      </ng-container>
    </div>
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  </div>
  <div class="footer">
    <div *ngIf="(uptimePercentage$ | async) as uptimePercentage">
      <span>Uptime: </span>
      <span class="uptime" [class.critical]="uptimePercentage < 80" [class.warning]="uptimePercentage < 95" [class.ok]="uptimePercentage >= 95">{{ uptimePercentage | number:'1.0-0' }}%</span>
    </div>
    @if (isMobile()) {
      <mat-form-field subscriptSizing="dynamic" class="time-range-select">
        <mat-label>Period</mat-label>
        <mat-select [value]="timeRange" (selectionChange)="selectTimeRange($event.value)">
          @for (option of timeRangeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    } @else {
      <mat-button-toggle-group [value]="timeRange" (change)="selectTimeRange($event.value)">
        <mat-button-toggle value="1d">1 Day</mat-button-toggle>
        <mat-button-toggle value="1w">1 Week</mat-button-toggle>
        <mat-button-toggle value="2w">2 Weeks</mat-button-toggle>
        <mat-button-toggle value="1m">1 Month</mat-button-toggle>
        <mat-button-toggle value="2m">2 Months</mat-button-toggle>
        <mat-button-toggle value="6m">6 Months</mat-button-toggle>
      </mat-button-toggle-group>
    }
  </div>
</div>